<script>
import { methods } from "./mixin";
export default {
    props: {
      user_id: {
        type: Number,
        default: 0,
      },
      first_name: {
        type: String,
        default: "",
      },
      sur_name: {
        type: String,
        default: ""
      },
      action_form_url: {
        type: String,
        default: ""
      },
      check_promo_status_url:{
        type: String,
        default: ""
      }
    },
    mixins: [methods],
    data() {
        return {
            cardHeight: 0,
            showARSModal: false,
            showPromoModal: false,
            showError: false,
            reg_id: 0,
            rule_id: 0,
            description: "",
            confirmation_text: "",
            submitted: false,
            submitting: false,
            redeemed: [],
            formdata: {
              firstname:"",
              surname:"",
              phone: "",
              street: "",
              city: "",
              state: "",
              postcode: "",
              country: "",
              user_id: "",
              reg_id: "",
              rule_id: "",
              // update_account: false
            },
            promo:{
              promoHeading:"",
              promoChecking:false,
              promoApproved:false,
              promoResponseText:"",
            }
        };
    },
    methods: {
        matchHeight(className) {
            let height = 0;
            for (const key in document.getElementsByClassName(className)) {
                if (
                    document
                        .getElementsByClassName(className)
                        .hasOwnProperty(key)
                ) {
                    const element = document.getElementsByClassName(className)[
                        key
                    ];
                    height =
                        height < element.scrollHeight
                            ? element.scrollHeight
                            : height;
                }
            }
            return height;
        },
        matchCardHeight() {
            this.cardHeight = 0;
            this.cardHeight = this.matchHeight("my_mic");
        },
        toggleARSModal(reg_id, rule) {
            if (
                typeof reg_id !== "undefined" &&
                typeof rule !== "undefined"
            ) {
                this.reg_id = reg_id;
                this.rule_id = rule.id;
                this.description = rule.description;
                this.confirmation_text = rule.confirmation_text;
                if(this.showARSModal === true){
                  this.showARSModal = false;
                  $("#RegModal").modal('hide');
                }else{
                  if(this.redeemed.indexOf(this.reg_id + "_" + this.rule_id) < 0 ){
                    this.submitted = false;
                    this.showARSModal = true;
                    this.formdata.rule_id = this.rule_id;
                    this.formdata.reg_id = this.reg_id;
                    $("#RegModal").modal('show');
                  }else{
                    alert('Your request is in the queue now.');
                  }
                } 
            }
        },
        closeModal(){
          this.showARSModal = false;
          this.reg_id = '';
          $("#RegModal").modal('hide');
        },
        togglePromoModal(promotion_name, reg_id, promo_id, user_id){
          if(this.showPromoModal){
            $("#PromoModal").modal('hide');
            this.showPromoModal = false;
            this.promo.promoApproved = false;
            this.promo.promoHeading = "";
          }else{
            this.promo.promoHeading = promotion_name;
            this.promo.promoApproved = false;
            this.checkPromo(reg_id, promo_id, user_id);
            $("#PromoModal").modal('show');
            this.showPromoModal = true;
          }
        },
        closePromoModal(){
          this.showPromoModal = false;
          $("#PromoModal").modal('hide');
        },
        submit(){
          this.submitting = true;
          this.showError = false;
          axios.post(this.action_form_url, this.formdata)
          .then(response => {
            // console.log(response);
            if(response.status === 200){
              let response_data = response.data;
              if(typeof response_data !== 'undefined'){
                if(typeof response_data.status !== 'undefined'){
                  if(response_data.status === 'success'){
                    this.submitted = true;
                    this.showError = false;
                    this.redeemed.push( this.reg_id + "_" + this.rule_id);
                  }
                }
              }
            }
            this.submitting = false;
          }).catch(error => {
            // console.error(error);
            this.showError = true;
            this.submitting = false;
          });
        },
        checkPromo(reg_id, promo_id, user_id){
          this.promo.promoChecking = true;
          let formdata = { reg_id: reg_id, promo_id: promo_id, user_id: user_id };
          axios.post(this.check_promo_status_url, formdata)
          .then(response => {
            this.promo.promoApproved = (response.data.status === 'approved');
            this.promo.promoResponseText = response.data.message;
            this.promo.promoChecking = false;
          }).catch(error => {
            console.error(error);
            this.promo.promoChecking = false;
          });
        },
    },
    created() {
        window.addEventListener("resize", this.matchCardHeight);
    },
    destroyed() {
        window.removeEventListener("resize", this.matchCardHeight);
    },
    computed: {
      show_rule_description() {
        return this.description.length > 0;
      }
    },
    mounted() {
        setTimeout(() => {
            this.cardHeight = this.matchHeight("my_mic");
        }, 0);
        tooltip();
        this.formdata.firstname = this.first_name;
        this.formdata.surname = this.sur_name;
        this.formdata.user_id = this.user_id;
    }
};
</script>

<style scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(173, 153, 112, 0.2);
  border-right: 1.1em solid rgba(173, 153, 112, 0.2);
  border-bottom: 1.1em solid rgba(173, 153, 112, 0.2);
  border-left: 1.1em solid #AD9970;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>